import {useToast as usePrimeVueToast} from "primevue/usetoast";
import {type ToastServiceMethods} from "primevue";
import {type ComposerTranslation, useI18n} from "vue-i18n";

export const useToast = (methods?: ToastServiceMethods, i18n?: { t: ComposerTranslation }) => {
    const toast = methods ?? usePrimeVueToast();
    const {t} = i18n ?? useI18n();

    return {
        makeErrorToast: (title: string) => {
            toast.add({
                severity: "error",
                summary: t("ERROR"),
                detail: title,
                life: 5000,
            });
        },
        makeWarningToast: (title: string) => {
            toast.add({
                severity: "warn",
                summary: t("WARNING"),
                detail: title,
                life: 5000,
            });
        },
        makeSuccessToast: (title: string) => {
            toast.add({
                severity: "success",
                summary: t("OPERATION_SUCCESSFUL"),
                detail: title,
                life: 5000,
            });
        }
    };
};
